namespace $.$$ {

	$mol_style_define( $shm_dashboard_app_dashboard_list, {
		minWidth: '220px',
		width: '20rem',
		maxWidth: '28vw',

		List_head: {
			flex: {
				grow: 1,
			},
		},

		Dashboard_menu: {
			flex: {
				direction: 'column',
				grow: 1,
			},
		},

		Dashboard_link: {
			justifyContent: 'flex-start',
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
		},
	} )

}
